import { useState, useEffect, useCallback, useMemo } from "react";
import { SimpleGrid, FormLabel } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import Loading from "../../../Component/Loading/loading";
import apiService from "../../../Method/Report/Report_Service";
import { ThemeProvider } from "@mui/material/styles";
import TableWidget from "../../../Component/Table/TableWidget";
import theme from "../../../assets/Table/TableTheme";
import { t } from "i18next";
import { useDataContext } from "../../../DataProvider";

const buildColumns = () => [
  {
    name: "BILL_DATE",
    label: t("DATE"),
    options: { filter: false, sort: false },
  },
  {
    name: "APP_NAME",
    label: t("APP_NAME"),
    options: {
      filter: false, sort: false
    },
  },

  {
    name: "PERCENTAGE",
    label: t("PERCENTAGE"),
    options: {
      filter: false, sort: false, customBodyRender: (value) => {
        return value ? `${value}%` : "0%";
      },
    },
  },

  {
    name: "TOT_APP",
    label: t("TOT_APP"),
    options: {
      filter: false, sort: false, customBodyRender: (value) => {
        return value ? value.toLocaleString() : "0";
      },
    },
  },
  {
    name: "NET_SALES",
    label: t("NET_SALES"),
    options: {
      filter: false, sort: false, customBodyRender: (value) => {
        return value ? value.toLocaleString() : "0";
      },
    },

  }
];

function App() {
  const { t } = useTranslation();
  const [data, setData] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const { trigger } = useDataContext();
  const [searchText, setSearchText] = useState("");


  const columns = useMemo(() => buildColumns(t), [t]);
  const [searchColumns, setSearchColumns] = useState(() =>
    columns.filter((c) => c.options?.search !== false).map((c) => c.name)
  );
  useEffect(() => {
    setSearchColumns(columns.filter((c) => c.options?.search !== false).map((c) => c.name));
  }, [columns]);

  const fetchData = useCallback(async () => {

    setLoading(true);
    const { success, data, error } = await apiService.search("GET_SALES_APPLICATION", page + 1, rowsPerPage);

    if (success && data) {
      setLoading(false);
      setData(data);
      setTotalCount(data.TOTAL_COUNT || 0);

      setError("")
    } else {
      setError(error.response.data.message);
      setLoading(false);
    }

  }, [page, rowsPerPage]);

  useEffect(() => {
    fetchData()
  }, [trigger, fetchData]);

  const filteredData = (data?.SALES_DETAILS || []).filter((row) => {
    const search = searchText.toLowerCase();

    return Object.values(row).some((value) => {
      return value?.toString().toLowerCase().includes(search);
    });
  });

  return (
    <ThemeProvider theme={theme}>

      {error && <p className="error-message">{error}</p>}
      {isLoading && <Loading />}
      <div>
        {!isLoading && (
          <div style={{ width: "100%", overflowX: "auto", marginTop: "10px" }}>
            <SimpleGrid
              className="Total_Header"

              columns={{ base: 1, md: 2 }}
            >
              <div>
                <div>
                  <FormLabel className="Total_Header_Right">
                    {t("NET_SALES")}
                  </FormLabel>
                  <FormLabel
                    className="Total_Header_Value"
                  >
                    {data.TOTAL_NET_SALES ? data.TOTAL_NET_SALES.toLocaleString() : "0"}
                  </FormLabel>
                </div>
              </div>

              <div>
                <FormLabel className="Total_Header_Left" >
                  {t("TOTAL_TOT_APP")}
                </FormLabel>
                <FormLabel
                  className="Total_Header_Value"

                >
                  {data.TOTAL_TOT_APP ? data.TOTAL_TOT_APP.toLocaleString() : "0"}
                </FormLabel>
              </div>
            </SimpleGrid>


            <TableWidget
              title={t("APPLICATION_SALES")}
              data={filteredData}
              onSearchChange={setSearchText}
              columns={columns}
              totalCount={totalCount}
              page={page}
              rowsPerPage={rowsPerPage}
              onPageChange={setPage}
              onRowsPerPageChange={setRowsPerPage}
              searchColumns={searchColumns}
              setSearchColumns={setSearchColumns}
            />


          </div>
        )}
      </div>
    </ThemeProvider >
  );
}

export default App;
